import { render, staticRenderFns } from "./CancelDispatch.vue?vue&type=template&id=60cd829e"
import script from "./CancelDispatch.vue?vue&type=script&lang=js"
export * from "./CancelDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports